import { Directive, PLATFORM_ID, ViewContainerRef, TemplateRef, OnInit, Input, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * A structural directive that conditionally includes a template based on if it
 * is being rendered server-side or client-side.
 *
 * @example
 * <span *finClientOnly ></span>
 */
@Directive({
  selector: '[finClientOnly]',
  standalone: false,
})
export class ClientOnlyDirective<T = unknown> implements OnInit {
  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject<TemplateRef<T>>(TemplateRef);
  private platform = inject(PLATFORM_ID);

  private clientOnly = true;

  /**
   * The Boolean expression indicating if the directive should be applied.
   * If false the content will always be rendered.
   */
  @Input()
  set finClientOnly(condition: boolean) {
    if (!(condition === null || condition === undefined)) {
      this.clientOnly = condition;
    }
    this.updateView();
  }

  ngOnInit(): void {
    this.updateView();
  }

  updateView(): void {
    this.viewContainer.clear();

    if (!this.clientOnly || isPlatformBrowser(this.platform)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
